import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import i18n from 'app/common/i18n';
import Paper from '@mui/material/Paper';
import {
  messages as getMessages,
  threadAction
} from 'app/redux/modules/messages';

import { setTitle } from 'app/layout/redux';
import MessageList from './message-list';
import Loading from 'app/common/Loading';

function getUser(user = {}) {
  return {
    id: user.id || user.get?.('id') || '',
    firstname: user.firstname || user.get?.('firstname') || '',
    lastname: user.lastname || user.get?.('lastname') || '',
    email: user.email || user.get?.('email') || '',
    phone: user.phone || user.get?.('phone') || '',
    uuid: user.uuid || user.get?.('uuid') || '',
    company: user.company || user.get?.('company') || '',
    companyAddress: user.companyAddress || user.get?.('companyAddress') || '',
    cvr: user.cvr || user.get?.('cvr') || '',
    type: user.type || user.get?.('type') || '',
    expireAt: user.expireAt || user.get?.('expireAt') || ''
  };
}

function isAdmin(user) {
  try {
    return (user && user.get('role') === 'admin') || false;
  } catch (e) {
    if (__DEV__) {
      console.error(e);
    }
  }

  return false;
}

function determineInterval(thread) {
  if (!thread) {
    return 10000;
  }

  const { latestMessage, active, closed } = thread;
  const MS_HOUR = 3600000;

  if (closed) {
    return 24 * MS_HOUR;
  }

  if (!active || !latestMessage || !latestMessage.createdAt) {
    return MS_HOUR;
  }

  const timestamp = new Date(latestMessage.createdAt).getTime();
  const current = new Date().getTime();

  if (timestamp > current - 0.1 * MS_HOUR) {
    return MS_HOUR / 120;
  } else if (timestamp > current - 0.25 * MS_HOUR) {
    return MS_HOUR / 30;
  } else if (timestamp > current - 0.5 * MS_HOUR) {
    return MS_HOUR / 10;
  } else if (timestamp > current - 1 * MS_HOUR) {
    return MS_HOUR / 4;
  } else if (timestamp > current - 2 * MS_HOUR) {
    return MS_HOUR / 2;
  }

  return MS_HOUR;
}

@connect(
  ({ dwellings, auth: { user } }) => ({
    dwellings,
    user
  }),
  {
    setTitle,
    getMessages,
    threadAction
  }
)
@i18n
class Messages extends Component {
  intervalId;

  constructor(props) {
    super(props);
    this.state = {};
  }

  setTiming(thread) {
    const timing = determineInterval(thread);
    clearInterval(this.intervalID);
    this.intervalID = setInterval(this.getData.bind(this), timing);
  }

  componentDidMount() {
    this.props.setTitle(this.props.i18n('Messages'));
    this.getData();
    this.intervalID = setInterval(this.getData.bind(this), 10000);
  }

  getData = async () => {
    const { params = {}, user: _user } = this.props;
    const { threadId } = params;

    if (!threadId) {
      return;
    }

    const user = getUser(_user);

    this.props.getMessages('thread', threadId).then((res) => {
      const data = res?.payload?.result || null;

      this.setState({ data });

      if (data) {
        this.setTiming(data);
      }
    });

    this.props.threadAction(threadId, {
      action: 'read',
      userId: user.id
    });
  };

  closeThread = async () => {
    const { params = {}, user: _user } = this.props;
    const { threadId } = params;

    if (!threadId) {
      return;
    }

    const user = getUser(_user);

    this.props
      .threadAction(threadId, {
        action: 'close',
        userId: user.id
      })
      .then((res) => {
        this.setState({
          data: res?.payload?.result || null
        });
      });
  };

  openThread = async () => {
    const { params = {}, user: _user } = this.props;
    const { threadId } = params;

    if (!threadId) {
      return;
    }

    const user = getUser(_user);

    this.props
      .threadAction(threadId, {
        action: 'open',
        userId: user.id
      })
      .then((res) => {
        this.setState({ data: res?.payload?.result || null });
      });
  };

  componentWillUnmount() {
    this.props.setTitle();
    clearInterval(this.intervalID);
  }

  render() {
    const { user: _user } = this.props;
    const user = getUser(_user);
    const admin = isAdmin(_user);

    return (
      <Paper
        style={{
          padding: '22px',
          marginBottom: '22px'
        }}
      >
        {this.state.data ? (
          <MessageList
            user={user}
            admin={admin}
            data={this.state.data}
            i18n={this.props.i18n}
            getData={this.getData}
            closeThread={this.closeThread}
            openThread={this.openThread}
          />
        ) : (
          <Loading />
        )}
      </Paper>
    );
  }
}

function MessagesWithRouter(props) {
  const params = useParams();

  return <Messages {...props} params={params} />;
}

export default MessagesWithRouter;
